/**
 * How to display the attribute group
 */
export var AttributeGroupVariant;
(function (AttributeGroupVariant) {
    /**
     * Display as an accordion
     */
    AttributeGroupVariant["Accordion"] = "Accordion";
    /**
     * Display content and title
     */
    AttributeGroupVariant["Simple"] = "Simple";
    /**
     * Display only content, not the title, e.g. for use in SubconfigurationNavigation.
     */
    AttributeGroupVariant["Content"] = "Content";
})(AttributeGroupVariant || (AttributeGroupVariant = {}));
/**
 * Determines the behavior of the attribute group
 * - for resetting
 * - for completeness
 */
export var AttributeGroupBehavior;
(function (AttributeGroupBehavior) {
    /**
     * Technical group as defined in the data manager
     */
    AttributeGroupBehavior["TechnicalGroup"] = "technical-group";
    /**
     * Visible attributes as arranged in the layout editor
     */
    AttributeGroupBehavior["VisibleAttributes"] = "visible-attributes";
    /**
     * All attributes as arranged in the layout editor
     */
    AttributeGroupBehavior["AllAttributes"] = "all-attributes";
})(AttributeGroupBehavior || (AttributeGroupBehavior = {}));
//# sourceMappingURL=AttributeGroupProps.js.map